import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { AbcCore } from '@barthauer/abc/core';
import { AbcCoreAuthenticationModule } from '@barthauer/abc/core/authentication';
import { AbcUiComponentsModule, _AbcSplitterComponent } from '@barthauer/abc/ui-components';
import { DxScrollViewModule } from 'devextreme-angular';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { ChoicemenuComponent } from './controls/choicemenu/choicemenu.component';
import { ContextmenuComponent } from './controls/contextmenu/contextmenu.component';
import { FcDirective } from './controls/fc-host.directive';
import { MapScaletextComponent } from './controls/map-scaletext/map-scaletext.component';
import { MapTooltipComponent } from './controls/map-tooltip/map-tooltip.component';
import { MeasureComponent } from './controls/measure/measure.component';
import { MovenodeControllerComponent } from './controls/movenode-controller/movenode-controller.component';
import { NetworktracingComponent } from './controls/networktracing/networktracing.component';
import { PathSelectorComponent } from './controls/path-selector/path-selector.component';
import { PrintComponent } from './controls/print/print.component';
import { HighlightSearchTreePipe } from './highlightSearchTree.pipe';
import { LegendComponent } from './legend.component';
import { MapComponent } from './map.component';
import { LegendSettingsService } from './services/legend-settings.service';
import { MapService } from './services/map.service';
import { FeatureSelectorComponent } from './controls/feature-selector/feature-selector.component';

@NgModule({
  declarations: [
    MapComponent,
    LegendComponent,
    MapScaletextComponent,
    MapTooltipComponent,
    HighlightSearchTreePipe,
    FcDirective,
    ContextmenuComponent,
    ChoicemenuComponent,
    PathSelectorComponent,
    MeasureComponent,
    PrintComponent,
    NetworktracingComponent,
    MovenodeControllerComponent,
    FeatureSelectorComponent,
  ],
  exports: [MapComponent, LegendComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatTreeModule,
    MatMenuModule,
    RouterModule.forRoot([], {}),
    MatRippleModule,
    MatInputModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatListModule,
    MatButtonToggleModule,
    MatBadgeModule,
    MatSelectModule,
    MatOptionModule,
    AbcUiComponentsModule,
    AbcCoreAuthenticationModule,
    FlexLayoutModule,
    DxScrollViewModule,
    _AbcSplitterComponent,
  ],
  providers: [MapService, LegendSettingsService, AbcCore, provideHttpClient(withInterceptorsFromDi())],
})
export class AbcGraphicsAdaptersOpenLayersModule {}
